import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, User, Phone, Mail, MapPin, ChevronRight } from "lucide-react";

const FleetyGoProfilePage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("fleety_user");
    if (!userData) {
      navigate("/login");
      return;
    }
    setUser(JSON.parse(userData));
  }, [navigate]);

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" data-testid="fleetygo-profile">
      <header className="bg-[#3FA9F5] p-4 flex items-center gap-4 sticky top-0 z-10">
        <button onClick={() => navigate("/fleetygo")} className="text-white">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-white text-lg font-semibold">Profile</h1>
      </header>

      <main className="flex-1 p-4">
        {/* Profile Header */}
        <div className="bg-white rounded-xl p-6 shadow-sm mb-4 text-center">
          <div className="w-20 h-20 bg-[#3FA9F5]/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <User className="text-[#3FA9F5]" size={40} />
          </div>
          <h2 className="text-xl font-bold text-gray-900">{user.full_name}</h2>
          <p className="text-gray-500">{user.phone_number}</p>
        </div>

        {/* Profile Details */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-4 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <Phone size={20} className="text-[#3FA9F5]" />
              <div className="flex-1">
                <p className="text-xs text-gray-500">Phone Number</p>
                <p className="font-medium text-gray-900">{user.phone_number}</p>
              </div>
            </div>
          </div>
          
          <div className="p-4 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <User size={20} className="text-[#3FA9F5]" />
              <div className="flex-1">
                <p className="text-xs text-gray-500">Full Name</p>
                <p className="font-medium text-gray-900">{user.full_name}</p>
              </div>
            </div>
          </div>
          
          <div className="p-4">
            <div className="flex items-center gap-3">
              <Mail size={20} className="text-[#3FA9F5]" />
              <div className="flex-1">
                <p className="text-xs text-gray-500">Email</p>
                <p className="font-medium text-gray-900">{user.email}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-4 bg-white rounded-xl shadow-sm overflow-hidden">
          <button
            onClick={() => navigate("/fleetygo/orders")}
            className="w-full p-4 flex items-center justify-between hover:bg-gray-50"
          >
            <span className="text-gray-700">My Deliveries</span>
            <ChevronRight size={20} className="text-gray-400" />
          </button>
          <button
            onClick={() => navigate("/fleetygo/favorites")}
            className="w-full p-4 flex items-center justify-between hover:bg-gray-50 border-t border-gray-100"
          >
            <span className="text-gray-700">Favorite Addresses</span>
            <ChevronRight size={20} className="text-gray-400" />
          </button>
          <button
            onClick={() => navigate("/payment-methods")}
            className="w-full p-4 flex items-center justify-between hover:bg-gray-50 border-t border-gray-100"
          >
            <span className="text-gray-700">Payment Methods</span>
            <ChevronRight size={20} className="text-gray-400" />
          </button>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">Profile synced with Fleety</p>
      </main>
    </div>
  );
};

export default FleetyGoProfilePage;
